module.exports = __webpack_public_path__ + "static/img/brees-2013-top-image-thumb.051a65c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-top-image-thumb.jpg
// module id = fZtt
// module chunks = 1